export function generateMenuIdFromSlug<T extends { href: string; htmlId?: string }>(item: T) {
  if (item.htmlId) return item.htmlId
  if (item.href && item.href.startsWith('/')) {
    return `menu-${item.href.substring(1, item.href.length)}`
  }

  return undefined
}
